module.exports = __webpack_public_path__ + "img/lloading.f1826d42.svg";